<nav class="navbar tantum-header">
  <div class="container-fluid">
    <div class="navbar-header">
      <div class="header-left">
        <a class="tantum-brand" href="/">
          <img src="assets/TantumIdent.svg" alt="TantumPay" class="tantum-logo">
        </a>
      </div>
      <div class="header-right">
        <a class="logout" (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</nav>
<router-outlet></router-outlet>
<footer class="tantum-footer">
  <div class="container-fluid">
    <div class="footer-content">
      <div class="footer-links">
        <a href="https://tantumpay.com/en/imprint/" class="footer-link" target="_blank">Imprint</a>
        <a href="https://tantumpay.com/en/privacy-policy/" class="footer-link" target="_blank">Privacy Policy</a>
        <a href="https://tantumpay.com/en/terms-and-conditions/" class="footer-link" target="_blank">Terms and Conditions</a>
      </div>
      <div class="footer-copyright">
        © 2025 Tantum AG, NFC-Ident Flow. All rights reserved.
      </div>
    </div>
  </div>
</footer>